'use strict';
moduleConfig.registerModule('eclipseApp.bts', ['eclipseApp.core']);
